angular.module('eatself')
.filter('ago', function() {
  return function(date) {
	return moment(date || new Date()).fromNow()
  };
})